import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidewalk = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 16V0H0V16H1ZM11.0005 10.9473V5.05253H10.0005V10.9473H11.0005ZM13.5009 10.9473V5.05253H12.5009V10.9473H13.5009ZM16.0003 5.05253V10.9473H15.0003V5.05253H16.0003ZM10.3336 13.1313C10.0575 13.1313 9.83362 13.3552 9.83362 13.6313V15.9998H8.83362V13.6313C8.83362 12.8029 9.50519 12.1313 10.3336 12.1313H16.0004V13.1313H10.3336ZM9.83362 2.36865C9.83362 2.6448 10.0575 2.86865 10.3336 2.86865L16.0004 2.86865V3.86865L10.3336 3.86865C9.50519 3.86865 8.83362 3.19708 8.83362 2.36865L8.83362 0.000231178L9.83362 0.000231354L9.83362 2.36865Z",
		fill: "currentColor"
	})
});
export default SvgSidewalk;
